export function getAlgoliaAgent(client) {
  var clientTyped = client;
  return clientTyped.transporter && clientTyped.transporter.userAgent ? clientTyped.transporter.userAgent.value : clientTyped._ua;
}